//
import { mapActions } from "vuex"

//
import { ModelForm } from "@/components/reusable_components/next"
import PosWorkstationUserModel from "@/models/General/GPosWorkstationUser"
import Translator from "@/services/translator"

//
import fields from "./fields"

//
export default {
    name: "pos-workstation-user-create",
    components: {
        ModelForm,
    },
    computed: {

        /**
         * 
         */
        isGroundSeller() {
            return this.formData.pos_workstation_type_id === 2
        },

        /**
         * 
         */
        formProps () {
            return {
                fields: this.isGroundSeller ? fields : fields.slice(0, 2),
            }
        },
    },
    data () {
        return {
            formData: {},
        }
    },
    methods: {

        //
        ...mapActions( "MenuesModule", [
             "setTitleTopBar",
        ]),

        /**
         * 
         */
        error(error) {
            console.log(error)
            this.$toast.error( Translator( PosWorkstationUserModel, error.response.data ) )
        },

        /**
         * 
         */
        redirect() {
            this.$router.push({ name: "pos-workstation-user-list" })
        },

        /**
         * 
         */
        reset() {
            this.formData = new PosWorkstationUserModel()
        },

        /**
         * 
         */
        submitCreate() {
            this.toWait(true)
                .then(this.toCreate)
                .then(this.successCreate)
                .then(this.redirect)
                .catch(this.error)
                .then(this.toWait)
        },

        /**
         * 
         */
        successCreate () {
            this.$toast.success("Punto de venta agregado.")
        },

        /**
         * 
         */
        toCreate(model) {
            return model.toCreate().save()
        },

        /**
         * 
         */
        toWait(value = false) {
            return this.$refs.form.setWait(value)
        },
    },
    beforeMount () {
        this.setTitleTopBar( "Crear punto de venta" )
    },
    mounted () {
        this.reset()
    }
}